import createTestId from "../../../fabrics/createTestId";
import { MEDIA_DISPLAY_NAME } from "../Media";

export const createTestIdForMediaElement = createTestId(MEDIA_DISPLAY_NAME);
